angular.module("Main").directive("vEmail", vEmail);

function vEmail() {
    return {
        restrict: "A",
        require: "ngModel",
        link: function (scope, element, attr, ngModel) {
            var validationFunction = function (viewValue) {
                var valid = (!_.isNil(viewValue) && validator.isEmail(viewValue));
                ngModel.$setValidity("vEmail", valid);

                return viewValue;
            };

            ngModel.$parsers.unshift(validationFunction);
            ngModel.$formatters.unshift(validationFunction);
        }
    }
}